import { css, SerializedStyles } from '@core-ui/react-stitch';

const getProductGridContainerStyles = (): SerializedStyles => css`
  width:100%;
`;

export {
  getProductGridContainerStyles
};
